import { useTranslation } from 'react-i18next';

import FieldsConfiguration from './FieldsConfiguration';
import SortingConfiguration from './SortingConfiguration';

export default function CollectionForm({
  formData,
  handleInputChange,
  handleSubmit,
  loading,
  draftField,
  handleDraftFieldChange,
  addField,
  updateField,
  removeField,
  getFieldTypeLabel,
  submitLabel,
  loadingLabel,
  onCancel,
  collections = [],
}) {
  const { t } = useTranslation();
  const submitText = loading ? loadingLabel : submitLabel;

  return (
    <form className="md:col-span-2" onSubmit={handleSubmit}>
      <div className="space-y-8">
        <div>
          <label htmlFor="name" className="block text-sm/6 font-medium text-gray-900">
            {t('customCollections.form.nameLabel')}
          </label>
          <div className="mt-2">
            <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleInputChange}
              placeholder={t('customCollections.form.namePlaceholder')}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <input
            id="visibleInMenu"
            name="visibleInMenu"
            type="checkbox"
            checked={!!formData.visibleInMenu}
            onChange={handleInputChange}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-600 border-gray-300 rounded"
          />
          <label htmlFor="visibleInMenu" className="text-sm text-gray-700">
            {t('customCollections.form.visibleInMenu')}
          </label>
        </div>

        <div className="flex items-center gap-2">
          <input
            id="showInParentCollection"
            name="showInParentCollection"
            type="checkbox"
            checked={!!formData.showInParentCollection}
            onChange={handleInputChange}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-600 border-gray-300 rounded"
          />
          <label htmlFor="showInParentCollection" className="text-sm text-gray-700">
            {t('customCollections.form.showInParentCollection')}
          </label>
        </div>

        <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
          <SortingConfiguration
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </div>

        <FieldsConfiguration
          fields={formData.fields || []}
          draftField={draftField}
          handleDraftFieldChange={handleDraftFieldChange}
          addField={addField}
          updateField={updateField}
          removeField={removeField}
          getFieldTypeLabel={getFieldTypeLabel}
          collections={collections}
        />
      </div>

      <div className="mt-8 flex gap-3">
        <button
          type="submit"
          disabled={loading}
          className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-200 ${
            loading
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'
          }`}
        >
          {submitText}
        </button>

        <button type="button" onClick={onCancel} className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50">
          {t('customCollections.form.actions.cancel')}
        </button>
      </div>
    </form>
  );
}
